import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useT } from "@/context/LanguageContext";

export function Footer() {
  const s = useSettings();
  const t = useT();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-ink text-ivory">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8 pt-14 pb-8">
        <div className="grid md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <p className="font-serif text-xl tracking-wide">RIVIERA HOST <span className="italic text-gold/90">Collection</span></p>
            <p className="text-ivory/50 text-sm mt-3">{t.footer.tagline}</p>
            <a href={`mailto:${s.email}`} className="inline-block mt-5 text-sm text-ivory/70 hover:text-gold transition-colors" data-testid="footer-email">{s.email}</a>
          </div>

          <div>
            <p className="overline text-ivory/50 mb-5">{t.footer.nav}</p>
            <ul className="space-y-2 text-sm">
              {[["/proprietaires", t.nav.owners], ["/collection", t.nav.collection], ["/a-propos", t.nav.about], ["/contact", t.nav.contact]].map(([to, label]) => (
                <li key={to}><Link to={to} className="text-ivory/70 hover:text-gold transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="overline text-ivory/50 mb-5">{t.footer.follow}</p>
            <a href={s.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 text-sm text-ivory/70 hover:text-gold transition-colors">
              <Instagram size={16} /> Instagram
            </a>
          </div>
        </div>

        <div className="border-t border-ivory/10 mt-12 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-ivory/50">
          <span>© {year} Riviera Host Collection</span>
          <span className="flex flex-wrap gap-x-2 gap-y-1">
            {["/mentions-legales", "/confidentialite", "/cookies"].map((to, i) => (
              <span key={to} className="flex items-center gap-2">
                {i > 0 && <span className="text-ivory/25">•</span>}
                <Link to={to} className="hover:text-ivory/80 transition-colors">{t.footer.legal[i]}</Link>
              </span>
            ))}
          </span>
        </div>
      </div>
    </footer>
  );
}
